import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SearchErrorComponent } from './search-error.component'
import { SharedModule } from '../shared/shared.module'



@NgModule({
  declarations: [SearchErrorComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [SearchErrorComponent]
})
export class SearchErrorModule { }
